import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setCollapsed } from 'store/requests/global';
import MainDashboard from '../../../components/Dashboard/MainDashboard';
import { useHistory } from 'react-router-dom';
import userHaveRolePermission from '../../../helpers/userHaveRolePermission';
import { PAGE_URLS } from '../../../helpers/endpoints';

const Dashboard = ({ collapsed, route }) => {
  const history = useHistory();
  const { isViewEnabled, isCrudEnabled } = userHaveRolePermission(route?.name);
  if (!isViewEnabled) {
    history.push(
      `${PAGE_URLS.LIVE_SCREEN}${PAGE_URLS.COURIER_PERFORMANCE_DASHBOARD}`,
    );
  }

  useEffect(() => {
    if (!collapsed) {
      setCollapsed(!collapsed);
    }
  }, []);

  return <MainDashboard />;
};

const mapStateToProps = (state) => ({
  collapsed: state.global.collapsed,
});

export default connect(mapStateToProps)(Dashboard);
